import { useGetVehiclesQuery } from "./useGetVehiclesQuery";

export const useGetVehicleById = (id: number) => {
  const { data } = useGetVehiclesQuery();

  return data?.resources.find(vehicle => vehicle.id === id);
};
